// @flow

/**
 * Show toast message
 * @param  {string} message message to show
 * @param  {boolean} isError error option
 */
export const showSABToast = (message: string, isError: boolean = false) => {
  const toastOptions = {
    duration: 5000,
    isError: isError
  };
  // const app = getSABAppInstance_Normal();
  // const toastNotice = Toast.create(app, toastOptions);
  // toastNotice.dispatch(Toast.Action.SHOW);
  if (window.shopify?.toast) {
    window.shopify.toast.show(message, toastOptions);
  }
};
